<template>
	<transition name="scroll">
		<div
			v-if="scrollY < 100"
			class="iv2-home__scroll-bar theme-c__scroll position-absolute d-none d-xl-block text-center"
		>
			<span class="iv2-home__scroll-bar-text">Scroll</span>
		</div>
	</transition>
</template>

<script>
export default {
	data() {
		return {
			scrollY: 0
		};
	},

	mounted() {
		window.addEventListener("scroll", this.handleScroll);
	},

	methods: {
		handleScroll() {
			this.scrollY = window.scrollY;
		},

		scrollTop: function() {
			window.scrollTo({
				top: 0,
				behavior: "smooth"
			});
		}
	}
};
</script>

<style lang="scss">
.iv2-home__scroll-bar {
	right: 33px;
	bottom: 30px;
	padding-bottom: 20px;
	font-size: 25px;
	font-weight: 400;
	letter-spacing: 0.5px;
	width: 115px;
	height: 160px;
	z-index: 5;

	&::before {
		content: "";
		width: 15px;
		height: 15px;
		border-bottom: 1px solid;
		border-right: 1px solid;
		-webkit-transform: rotate(45deg);
		transform: rotate(45deg);
		position: absolute;
		left: 50%;
		bottom: 0;
		transform: translateY(calc(-50% + 5px)) translateX(-50%) rotate(45deg);
		-webkit-transform: translateY(calc(-50% + 5px)) translateX(-50%)
			rotate(45deg);
	}

	&::after {
		content: "";

		height: 85px;
		width: 1px;
		position: absolute;
		left: 50%;
		bottom: 0;
		transform: translateX(-50%);
		-webkit-transform: translateX(-50%);
	}

	&.scroll-enter-active,
	&.scroll-leave-active {
		transition: all 1s ease;
	}

	&.scroll-enter,
	&.scroll-leave-to {
		transform: translateY(150px) !important;
		opacity: 0;
	}
}
</style>